import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import ReactGA from 'react-ga'

class ScheduleList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            list: null,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadSchedule()
    }

    loadSchedule = () => {
        axios
            .get(`${BACKEND_HOST}/schedules?project_id=${this.props.cookies.get('project')}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ list: res.data.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        console.log(this.state)

        const processes = []
        const allProcesses = this.state.list
        if (allProcesses && allProcesses.length > 0) {
            for (let i = 0; i < allProcesses.length; i += 1) {
                const startDate = new Date(allProcesses[i].start_date)
                const endDate = new Date(allProcesses[i].end_date)
                const curDate = new Date()
                if (curDate >= startDate && curDate <= endDate) {
                    console.log(allProcesses[i])
                    processes.push(<div>{allProcesses[i].text}</div>)
                }
            }
        }

        return (
            <div className="schedule_wrap box_wrap">
                <Link
                    to={'/schedule/'}
                    onClick={() => {
                        ReactGA.event({ category: '대시보드_건축주', label: '오늘의 스케줄', action: '더보기' })
                    }}>
                    <div className="box_more_btn">
                        더 보기
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
                            <path
                                fill="none"
                                fillRule="evenodd"
                                stroke="#A2A7AE"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.3"
                                d="M1.56.95L6.06 5l-4.5 4.05"
                            />
                        </svg>
                    </div>
                </Link>
                <h1>오늘의 스케줄</h1>

                {processes.length > 0 ? (
                    <div className="schedule_list_wrap">{processes}</div>
                ) : (
                    <div className="schedule_list_wrap_no">
                        <p>오늘의 스케줄이 없습니다.</p>
                    </div>
                )}
            </div>
        )
    }
}

export default withCookies(ScheduleList)



// WEBPACK FOOTER //
// ./Src/Components/Dashboard/OwnerScheduleList.js